import React from "react";
import ReactDOM from "react-dom";
import AggregateReviews from "./containers/AggregateReviews";

const aggregateApp = () => {
  const e = document.getElementById("aggregatedWidget");
  if (e) {
    ReactDOM.render(<AggregateReviews {...e.dataset} />, e);
  }
};

aggregateApp();



// WEBPACK FOOTER //
// ./src/aggregate.js